import * as React from 'react';
export const IcRoamingNetwork = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.16 8.08A3 3 0 006 3H4a1 1 0 00-1 1v6a1 1 0 002 0V9h1c.12.01.24.01.36 0l.75 1.49A1 1 0 008 11a.931.931 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47zM6 7H5V5h1a1 1 0 110 2zm0 10a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zM18.71 3.29A1 1 0 0017 4v16a1 1 0 002 0V4a1 1 0 00-.29-.71zM14 7a1 1 0 00-1 1v12a1 1 0 002 0V8a1 1 0 00-1-1zm-4 6a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
